import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConstantsModule } from './../constants/constants.module';
import { DialogPage } from './../root_classes/dialog-page';

@Component({
	selector: 'app-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent extends DialogPage implements OnInit {

	public httpHeaders: HttpHeaders = new HttpHeaders({
		'authorization': 'bearer ' + this.cookieService.get(this.constantsModule.cookieToken),
	});

	public uploadedFiles: any[] = [];
	public urlServer: string = "";

	constructor(constantsModule:ConstantsModule, cookieService:CookieService, httpClient:HttpClient, router:Router, modalService:NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);
	}

	ngOnInit(): void {
		this.urlServer = this.constantsModule.serverFullURL + "/api/upload";
	}

	public setModalOptions(data:any): void {
		// Storing the folderId.
		this.httpHeaders = this.httpHeaders.set("folderid", data["folderId"]);
	}

	public onUpload(event:any) {
		this.modalInstance.dismiss("OK");
	}

	public onError(event:Event): void {
		this.modalInstance.close("KO");
	}

}
